import { Button } from "@mantine/core";
import { Icon } from "@components/Icon/Icon.jsx";

export function Cta ({ url, title, icon, alignment, variant, size, target, color = 'violet.6' }) {
    const bsize = size ? "xl" : "md";
    return (
        <Button component="a" href={url} variant={variant} color={color} size={bsize} className={alignment} target={target ? '_blank' : ''} autoContrast={true}>{alignment == "icon-left" && <Icon name={icon} />}{title}{alignment == "icon-right" && <Icon name={icon} />}</Button>
    )
}
